import { useState, useEffect, useReducer, useContext } from "react";
import { Store } from "@store";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { getLimitText } from "@utils/text/getLimitText";
import { time_ago } from "@utils/metrics/timeFunction";
import getText from "@utils/text/textBuilder";
import classNames from "classnames/bind";
import memberStyles from "../styles/member.module.css";
import postClasses from "../styles/post.module.css";
import { likePost, unlikePost } from "@queries/posts.queries";
import { requestToJoin } from "@queries/community.queries";
import { viewHashtagPosts } from "@utils/viewPage";
import { COMMUNITY_MEMBER_ROLES, COMMUNITY_SECURITY_TYPES, FEED_TYPES, HTTP_STATUS_CODES, getMemberRole } from "@utils/constants";
import { createComment } from "@queries/comment.queries";
import { getLinkDataFromText } from "@utils/text/getLinkDataFromText";
import { getSource } from "@utils/analytics/event-analytics";
import { getCommentData } from "@utils/comment/helpers";
import { getViewerRole } from "@utils/post/helpers";
import { ViewSinglePostModalContext } from "@components/context/ViewSinglePostModal";
import ProfilePreview from "../../../components/post/ProfilePreview";
import { Divider } from "@mui/material";
import BlockedUserModal from "@components/modal/BlockedUserModal";
import RightArrowPost from "../../../public/assets/icons/RightArrowPost.svg";
import GuestUserModal from "src/globalModule/components/guestUserModal";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

/*---------------------- To be loaded at client-side only ---------------------------*/

// icons

const LikeIcon = dynamic(() => import("@public/assets/icons/likeIcon.svg"), {
  ssr: false
});
const LikedIcon = dynamic(() => import("@public/assets/icons/likedIcon.svg"), {
  ssr: false
});
const CommentIcon = dynamic(() => import("@public/assets/icons/comment.svg"), {
  ssr: false
});

//

// import RenderMediaComponent from "./RenderMediaComponent";
const RenderMediaComponent = dynamic(() => import("../../../components/post/RenderMediaComponent"), {
  ssr: false
});
const LinkPreview = dynamic(() => import("../../../components/post/LinkPreview"), {
  ssr: false
});
const TopComment = dynamic(() => import("@components/comments/TopComment"), {
  ssr: false
});
const PostMoreOptions = dynamic(() => import("../../../components/post/PostMoreOptions"), {
  ssr: false
});
const PostShareOptions = dynamic(() => import("../../../components/post/PostShareOptions"), {
  ssr: false
});
const AllComments = dynamic(() => import("@components/comments/AllComments"), {
  ssr: false
});
const WriteComment = dynamic(() => import("@components/comments/WriteComment"), {
  ssr: false
});
const SuggestedComments = dynamic(() => import("@components/comments/SuggestedComments"), {
  ssr: false
});
const UtsavModal = dynamic(() => import("src/globalModule/components/UtsavModal"), {
  ssr: false
});
const GuestPopup = dynamic(() => import("@components/modal/GuestPopup"), {
  ssr: false
});

/*--------------------------- components end ------------------------------*/

function Post2({
  postData,
  singlepostview = false,
  deletePostLocally = null,
  commentValue = false
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const {
    dispatch: viewSinglePostModalContextDispatch
  } = useContext(ViewSinglePostModalContext);
  const postUser = {
    ...postData?.User,
    ...postData?.CommunityMember
  };
  const postCommunity = {
    ...postData?.Community,
    communityID: postData?.communityID
  };
  const [headline, setHeadline] = useState("");
  const [limited_text, set_limited_text] = useState("");
  // const [l_headline, set_limited_headline] = useState("");
  const [moreTextFlag, setMoreTextFlag] = useState(false);
  const [text, setText] = useState("");
  const [showMoreText, setShowMoreText] = useState(false);
  const [Liked, setLiked] = useReducer(changeIsLiked, postData?.isLiked);
  const [comments, setComments] = useState(postData?.comments ? postData?.comments : []);
  const [likeCount, setLikeCount] = useReducer(changeLikeCount, postData?.likeNo);
  const [cmtNo, setCmtNo] = useReducer(changeCommentCount, postData?.commentNo);
  const [viewerRole, setViewerRole] = useState(getViewerRole(postData?.viewerRole));
  const [changeViewerRole, setChangeViewerRole] = useState(false);
  const clips = FEED_TYPES.VIDEO === postData?.postType;
  const postType = clips === true ? "clips" : "feeds";

  // const [showLikeList, setShowLikeList] = useState(false);
  const [showLikeAnimation, setShowLikeAnimation] = useState(false);
  const [suggestedComment, setSuggestedComment] = useState(null);
  const [openUnauthorizedModal, setOpenUnauthorizedModal] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  // const smallScreen = useMediaQuery(
  //   json2mq({
  //     maxWidth: 600,
  //   })
  // );

  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const handleOpenUnauthorizedModal = () => {
    // trackEvent("Sign Up From Guest Cancelled");

    setOpenUnauthorizedModal(!openUnauthorizedModal);
  };

  // const l_headline = getLimitText(postData?.headline, null, 150, 2);

  useEffect(() => {
    // set_limit_headline(l_headline);
    // setHeadline(l_headline.limited_text);

    let limit = 300,
      lineLimit = 3;
    if (window.innerWidth < 750 && singlepostview) {
      limit = 800;
      lineLimit = 8;
    } else if (singlepostview) {
      limit = 1200;
      lineLimit = 12;
    }
    const {
      limited_text: l_text,
      moreTextFlag: mT
    } = getLimitText(postData?.text, postData?.FeedPostUserTags, limit, lineLimit);
    set_limited_text(l_text);
    setMoreTextFlag(mT);
    setText(l_text);
    setLiked(postData?.isLiked);
    setCmtNo(postData?.commentNo);
  }, [postData, singlepostview]);

  // useEffect(() => {
  //   setLiked(postData?.isLiked);
  //   setLikeCount(postData?.likeNo);
  //   setCmtNo(postData?.commentNo);
  // }, [postData]);

  /**-------- Conditional Styling start -------**/
  const cx = classNames.bind(memberStyles);
  const roleStyle = cx({
    post_header_badge: true,
    owner: postUser.role === COMMUNITY_MEMBER_ROLES.OWNER,
    admin: postUser.role === COMMUNITY_MEMBER_ROLES.ADMIN,
    hide: postUser.role !== COMMUNITY_MEMBER_ROLES.OWNER && postUser.role !== COMMUNITY_MEMBER_ROLES.ADMIN
  });
  const cl = classNames.bind(postClasses);
  const likeIconStyles = {
    like: cl({
      post_icon: true,
      post_icon_like: true
    }),
    liked: cl({
      post_icon: true,
      post_icon_liked: true
    })
  };

  // router link
  let currentLink = "/" + router.pathname.split("/")[1];
  const {
    params
  } = router.query;
  params?.map(query => {
    currentLink += `/${query}`;
  });

  /**-------- Conditional Styling end -------**/

  // FOR LOCAL SYNCRONIZATION
  function localChangeHandler(comment_data, post_data) {
    setComments(comment_data);
    if (Liked !== post_data.isLiked) setLiked({
      type: "update",
      newState: post_data.isLiked
    });
    if (likeCount !== post_data.likeNo) setLikeCount({
      type: "update",
      newState: post_data.likeNo
    });
    if (cmtNo !== post_data.cmtNo) setCmtNo({
      type: "update",
      newState: post_data.cmtNo
    });
  }
  const likeHandle = async event => {
    event.preventDefault();
    // console.log("likeHandle");

    if (!loggedInUser.authType) {
      // trackEvent("Sign Up From Guest Dialog Opened");

      // setOpenUnauthorizedModal(true);
      // if (smallScreen) setLoginModalOpen(true);
      setLoginModalOpen(true);
      return () => {};
    }
    if (postData.Community.securityType !== COMMUNITY_SECURITY_TYPES.PUBLIC && !postData.viewerRole) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("you-are-not-member-of-the-community")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }

    // trackEvent("Post Like Clicked", { Source: getSource(router) });

    if (Liked) {
      const unlike_res = await unlikePost({
        feedID: postData.feedID,
        accessToken: loggedInUser.accessToken
      });
      if (unlike_res && !unlike_res.data.success && unlike_res.data.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(like_res.data.message);
        toggleBlockedServiceModal();
        return () => {};
      }
      setLiked({
        type: "unliked"
      });
      setLikeCount({
        type: "decrement"
      });
    } else {
      const like_res = await likePost({
        feedID: postData.feedID,
        accessToken: loggedInUser.accessToken
      });
      if (like_res && !like_res.data.success && like_res.data.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(like_res.data.message);
        toggleBlockedServiceModal();
        return () => {};
      }
      setShowLikeAnimation(true);
      setLiked({
        type: "liked"
      });
      setLikeCount({
        type: "increment"
      });

      // if (like_res)
      // trackEvent("Post Liked", {
      //   Source: getSource(router),
      //   LikeType: "Pranam",
      // });
      // else
      // trackEvent("Post Like Failed", {
      //   Source: getSource(router),
      //   LikeType: "Pranam",
      // });
    }
  };

  // function openLikeListModal() {
  //   if (likeCount > 0) setShowLikeList(true);
  // }

  // function closeLikeList() {
  //   setShowLikeList(false);
  // }

  function addComment(data) {
    if (data?.success == false && data?.message === `${t("comment-contains-vulgar-words")}`) {
      setErrorModal({
        open: true,
        heading: `${t("your-comment-contains-vulgar-words")}`,
        message: `${t("please-remove-them-and-try-again-0")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />,
        positive: false
      });
    } else {
      const totalCommentData = getCommentData({
        data,
        User: loggedInUser,
        userRole: postData.viewerRole
      });
      if (comments.length === 0) setComments([totalCommentData]);else setComments([totalCommentData, comments[0]]);
      setCmtNo(cur => cur + 1);
    }
  }
  const deleteCommentLocally = id => {
    const array = comments.filter(item => {
      if (item.commentID !== id) {
        return item;
      } else return null;
    });
    setComments([...array]);
    setCmtNo(cur => cur - 1);
  };
  const Comments = (comment, index) => {
    return <TopComment key={index.toString()} comment={comment} postType={postType} data-sentry-element="TopComment" data-sentry-component="Comments" data-sentry-source-file="post.jsx" />;
  };
  const onHashtagClick = value => {
    viewHashtagPosts(value, postType, router);
  };
  function showMoreTextHandle(e) {
    if (showMoreText) {
      e.currentTarget.innerHTML = `${t("show-more-0")}`;
      setText(limited_text);
    } else {
      e.currentTarget.innerHTML = `${t("show-less")}`;
      setText(postData.text);
    }
    setShowMoreText(!showMoreText);
  }
  async function joinBtnHandler() {
    if (!loggedInUser.authType) {
      //setOpenUnauthorizedModal(true);
      //if (smallScreen) setLoginModalOpen(true);
      setLoginModalOpen(true);
      return () => {};
    }
    if (postCommunity.securityType === COMMUNITY_SECURITY_TYPES.PRIVATE) {
      setViewerRole("requested");
    }
    if (postCommunity.securityType === COMMUNITY_SECURITY_TYPES.PUBLIC) {
      setViewerRole("joined");
      setChangeViewerRole(true);
    }
    const res = await requestToJoin({
      communityID: postData.communityID,
      accessToken: loggedInUser.accessToken
    });
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
  }
  function viewPost(options) {
    if (options?.source) if (window.innerWidth < 750) {
      // trackEvent("Single Post View Opened", { Source: options.source });

      if (clips) {
        router.push("/clip/" + postData.feedID);
      } else {
        router.push("/post/" + postData.feedID);
      }
      return () => {};
    }
    if (viewSinglePostModalContextDispatch) {
      viewSinglePostModalContextDispatch({
        type: "OPEN",
        payload: {
          postData,
          viewerRole,
          changeViewerRole: setViewerRole
        }
      });
    }
  }
  async function onSuggestedTagClick(tag) {
    const text = " " + tag + " ";
    //setSuggestedComment(text);
    const data = {
      feedID: postData?.feedID,
      communityID: postData?.communityID,
      comment: text
    };
    const source = getSource(router);

    // trackEvent("Suggested Comment Clicked", { Source: source });

    const res = await createComment({
      data: data,
      accessToken: loggedInUser.accessToken
    });
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }

    // console.log("Create Suggested Comment => ", res);

    if (tag && res) {
      addComment(res);
      // trackEvent("Suggested Comment Created", {
      //   Source: source,
      //   "HashTag Count": res.tagList?.length || 0,
      // });
    } else {
      // trackEvent("Suggested Comment CreatIon Failed", {
      //   Source: source,
      //   "HashTag Count": 0,
      // });
    }
  }
  return <div className={`${postClasses.post} ${commentValue && postClasses.single_post}`} data-sentry-component="Post2" data-sentry-source-file="post.jsx">
      {" "}
      <div className={postClasses.post__header}>
        <ProfilePreview postUser={postUser} postCommunity={postCommunity} data-sentry-element="ProfilePreview" data-sentry-source-file="post.jsx" />
        <div className={postClasses.post_header_inner}>
          <div className={postClasses.post_community_name_container}>
            <Link className={postClasses.post_community_name} scroll={false} href={`/community/${postData?.Community?.urlExtension}`} passHref rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="post.jsx">
              {postCommunity?.name}{" "}
            </Link>
            <span style={{
            marginLeft: "8px"
          }}>
              {" "}
              <RightArrowPost data-sentry-element="RightArrowPost" data-sentry-source-file="post.jsx" />
            </span>
            <span className={postClasses.userName}>
              {" "}
              <Link className={postClasses.post_user_header} scroll={false} href={`/profile/${postData?.uid}`} passHref rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="post.jsx">
                <small className={`${postClasses.text_clip} ${postClasses.post_username}`}>
                  {`${t("by")}  ` + postUser.name}
                </small>
              </Link>
            </span>
          </div>
          <div className={postClasses.post_name_time}>
            <div>
              {" "}
              <h6 className={roleStyle}>
                {getMemberRole(postUser.role, router.locale)}
              </h6>
            </div>
            <small suppressHydrationWarning={true} className={postClasses.timestamp}>
              {` • `} {time_ago(postData?.ts)}
            </small>
            <span className={postClasses.post_join_btn_container}>
              {viewerRole ? <>
                  {viewerRole === "requested" && <>
                      <span className={postClasses.requested}>
                        {viewerRole}
                      </span>
                    </>}
                </> : <>
                  <span className={postClasses.join_btn} onClick={joinBtnHandler}>
                    {t("join")}
                  </span>
                </>}
            </span>
          </div>
        </div>
        <div className={postClasses.post_more_options}>
          <PostMoreOptions postUid={postData?.uid} feedID={postData?.feedID} viewerRole={postData?.viewerRole} clips={clips} singlepostview={singlepostview} viewPost={viewPost} deletePostLocally={deletePostLocally} data-sentry-element="PostMoreOptions" data-sentry-source-file="post.jsx" />
        </div>{" "}
      </div>
      {postData?.headline && <>
          <h4 className={postClasses.post_headline} onClick={() => {
        if (!singlepostview) {
          viewPost({
            source: "Headline"
          });
        }
      }}>
            {postData.headline}
          </h4>
        </>}
      {postData?.text && <>
          <div className={postClasses.post__text}>
            <span onClick={() => {
          if (!singlepostview) {
            viewPost({
              source: "Text Content"
            });
          }
        }}>
              {getText(text, postData.FeedPostUserTags, onHashtagClick)}
            </span>
            {moreTextFlag && <span className={postClasses.show_more_text} onClick={showMoreTextHandle}>
                ...Show more
              </span>}
          </div>
        </>}{" "}
      <RenderMediaComponent data={postData} viewPost={viewPost} viewfor="feed" data-sentry-element="RenderMediaComponent" data-sentry-source-file="post.jsx" />{" "}
      {postData?.postType === FEED_TYPES.LINK && <LinkPreview data={postData?.linkMetaData} />}
      {postData?.postType === FEED_TYPES.TEXT && <LinkPreview data={getLinkDataFromText(postData.text)} />}
      <div className={postClasses.post__options}>
        <div className={postClasses.like}>
          {Liked ? <LikedIcon className={likeIconStyles.liked} onClick={likeHandle} /> : <LikeIcon className={likeIconStyles.like} onClick={likeHandle} />}

          <p className={postClasses.likeCount}>
            {likeCount > 0 ? likeCount : null}
          </p>
        </div>

        <div className={postClasses.comment} onClick={viewPost}>
          <div className={`${postClasses.post_icon} ${postClasses.post_icon_comment}`}>
            <CommentIcon className={postClasses.commentIcon} data-sentry-element="CommentIcon" data-sentry-source-file="post.jsx" />
          </div>
          <p className={postClasses.commentCount}>{cmtNo > 0 ? cmtNo : null}</p>
        </div>
      </div>{" "}
      {/* <hr className={postClasses.hrAboveComment} />{" "} */}
      <Divider sx={{
      opacity: 0.5
    }} data-sentry-element="Divider" data-sentry-source-file="post.jsx" />
      {commentValue && <AllComments feedID={postData?.feedID} communityID={postData?.communityID} userRole={postData?.viewerRole} deleteCommentLocally={deleteCommentLocally} />}
      {!commentValue && <>
          <div className={postClasses.commentContainer}>
            {comments?.length > 0 && comments.map(Comments)}
          </div>

          {(showLikeAnimation || changeViewerRole) && <SuggestedComments onClickHandler={onSuggestedTagClick} suggestedComments={postData.suggestedComments} />}

          <WriteComment feedID={postData?.feedID} communityID={postData?.communityID} addComment={addComment} suggestedComment={suggestedComment} />
        </>}
      {/* ========== COMMENT SECTION END========== */}
      {/* <ListModal
        show={showLikeList}
        heading="Liked by"
        setShowList={closeLikeList}
       >
        <LikeList for="post" postid={postData?.feedID} postType={postType} />
       </ListModal> */}
      {/*console.log(currentLink)*/}
      {/* {smallScreen && openUnauthorizedModal && (
        <GuestPopup
          open={openUnauthorizedModal}
          toggleModal={handleOpenUnauthorizedModal}
          link={currentLink}
        ></GuestPopup>
        // <GuestUserModal
        //   isLoginModalOpen={isLoginModalOpen}
        //   setLoginModalOpen={setLoginModalOpen}
        // />
       )} */}
      {/* {!smallScreen && openUnauthorizedModal && (
        <UtsavModal
          open={openUnauthorizedModal}
          toggleModal={handleOpenUnauthorizedModal}
          heading="Login / Sign up to continue"
          message="To access this feature you need to register yourself"
          acceptMsg="Continue"
          onAccept={() => {
            // trackEvent("Sign Up From Guest Clicked");
            setLoginModalOpen(true);
            // router.push({
            //   pathname: "/onboarding",
            //   query: {
            //     login: true,
            //     type: "community",
            //     communityID: `${postData?.communityID}`,
            //     feedID: postData?.feedID,
            //   },
            // });
          }}
          rejectMsg="Cancel"
        />
       )} */}
      {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} />}
      {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg={t("contact-utsav")} rejectMsg={t("cancel")} />}
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg={t("okay")} onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </div>;
}
export default Post2;
function changeIsLiked(state, action) {
  if (action && action.type === "liked") return true;else if (action && action.type === "unliked") return false;else if (action && action.type === "update") return action.newState;
  return state;
}
function changeLikeCount(state, action) {
  if (action && action.type === "increment") return state + 1;else if (action && action.type === "decrement") return state - 1;else if (action && action.type === "update") return action.newState;
  return state;
}
function changeCommentCount(state, action) {
  if (action && action.type === "increment") return state + 1;else if (action && action.type === "decrement") return state - 1;else if (action && action.type === "update") return action.newState;
  return state;
}